import React from 'react';

function GameOverModal({ onReset, onMenu, progress }) {
  return (
    <div className="absolute flex flex-col items-center justify-center w-full h-full bg-black bg-opacity-60">
      <img
        src="/gameoverUi.png"
        alt="Game Over"
        className="w-[200px] sm:w-[240px] landscape:w-[200px] mb-2"
      />
      {/* Progress UI */}
      <div className="relative mb-2">
        <img
          src="/progressUi.png"
          alt="Progress"
          className="w-[120px] sm:w-[140px] landscape:w-[120px]"
        />
        <span
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[#00f0ff] text-lg sm:text-xl font-bold"
          style={{ textShadow: '0 0 8px #00f0ff, 0 0 12px #00f0ff' }}
        >
          {progress}%
        </span>
      </div>
      <div className="flex justify-center gap-4">
        <button
          onClick={onReset}
          className="bg-transparent p-2 rounded-full transition-all duration-300 hover:bg-pink-500/10 hover:shadow-[0_0_12px_rgba(219,39,119,0.5)]"
        >
          <img
            src="/resetUi.png"
            alt="Reset"
            className="w-14 h-14 sm:w-16 sm:h-16 landscape:w-14 landscape:h-14"
          />
        </button>
        <button
          onClick={onMenu}
          className="bg-transparent p-2 rounded-full transition-all duration-300 hover:bg-pink-500/10 hover:shadow-[0_0_12px_rgba(219,39,119,0.5)]"
        >
          <img
            src="/homeUi.png"
            alt="Menu"
            className="w-14 h-14 sm:w-16 sm:h-16 landscape:w-14 landscape:h-14"
          />
        </button>
      </div>
    </div>
  );
}

export default GameOverModal;